<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/kampanya/listesi">{{ $t('menu.campaigns') }}</router-link> / {{ item.name }}
        </div>
        <div class="va-card__header-actions"/>
      </template>
    </va-card>
    <div class="row align--center">
      <div class="flex xs12 md6 offset--md3 text--center">
        <div class="grid__container flex-center">
          {{ formatDate(item.start_at) + ' - ' + formatDate(item.end_at) }}
        </div>
      </div>
    </div>
    <div class="row d-flex wrap align--start">
      <div class="flex md6 xs12">
        <va-card
          overlay
          titleOnImage
          :image="item.image_paths_readable.tr ? item.image_paths_readable.tr : ''"
          :title="item.name"
        >
          <template slot="actions">
            <va-badge :color="getCampaignColor()">
              {{ getCampaignValue() }}
            </va-badge>
          </template>
          <p class="title">{{item.title.tr}}</p>
          <div>{{item.description.tr}}</div>
        </va-card>
        <div class="text--right">
          <va-button color="info" icon="fa fa-edit" :to="'/kampanya/'+item.id+'/duzenleme'">{{ $t('tables.actions.edit') }}</va-button>
        </div>
      </div>
      <div class="flex md6 xs12">
        <va-card
          v-if="!!item.title.en"
          overlay
          titleOnImage
          :image="item.image_paths_readable.en ? item.image_paths_readable.en : ''"
          :title="item.name"
        >
          <template slot="actions">
            <va-badge :color="getCampaignColor()">
              {{ getCampaignValue() }}
            </va-badge>
          </template>
          <p class="title">{{item.title.en}}</p>
          <div>{{item.description.en}}</div>
        </va-card>
        <div v-if="!!item.title.en" class="text--right">
          <va-button color="info" icon="fa fa-edit" :to="'/kampanya/'+item.id+'/ceviri'">{{ $t('tables.actions.translate') }}</va-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import campaignServices from '../../services/api/campaign'
export default {
  data () {
    return {
      item: {
        image_paths_readable: {},
        title: {},
        description: {}
      }
    }
  },
  methods: {
    async getCampaign(id) {
      const result = await campaignServices.get(id, {
        params: {
          'include': 'vehicles'
        }
      });
      if(result.error){
        return ;
      }
      this.item = result.data.data;
    },
    formatDate (date) {
      if (date) {
        return moment(String(date)).format("DD.MM.YYYY");
      }
      return date;
    },
    getCampaignColor () {
      if (this.item.apply_type === 'decrease') {
        return 'danger'
      }

      return 'info'
    },
    getCampaignValue () {
      let sign = this.item.apply_type === 'decrease' ? '-' : '+',
          value = this.item.amount,
          type = this.item.amount_type === 'percent' ? '%' : '₺';
      return sign + value + type;
    }
  },
  created () {
    if(this.$route.params.id) {
      this.getCampaign(this.$route.params.id);
    }
  }
}
</script>

<style lang="scss">
$theme-secondary: #0e3e92;
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
    background-color: $theme-secondary;
  }
}
</style>